import React, { useCallback, useEffect, useState, memo } from 'react';
import { Box, Container, Flex, Link, IconButton, useDisclosure, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, VStack } from '@chakra-ui/react';
import { Menu } from 'lucide-react';
export const Navigation = memo(function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclosure();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = useCallback((id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    onClose();
  }, [onClose]);
  const scrollToTop = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);
  const navLinks = [{
    label: 'About',
    id: 'about'
  }, {
    label: 'Tools',
    id: 'tools'
  }, {
    label: 'Projects',
    id: 'projects'
  }, {
    label: 'Contact',
    id: 'contact'
  }];
  return <>
      <Box as="nav" position="sticky" top={0} zIndex={1000} bg={isScrolled ? 'white' : 'transparent'} bgGradient={isScrolled ? 'none' : 'linear(to-r, #2c0842, #1E73BE)'} shadow={isScrolled ? 'md' : 'none'} transition="all 0.3s" role="navigation" aria-label="Main navigation" data-id="element-88">
        <Container maxW="container.xl" data-id="element-89">
          <Flex justify="space-between" align="center" py={4} data-id="element-90">
            <Link href="#" fontSize="lg" fontWeight="bold" color={isScrolled ? '#1E73BE' : 'white'} onClick={scrollToTop} cursor="pointer" _hover={{
            textDecoration: 'none',
            opacity: 0.8
          }} aria-label="Martin's AI Kit - Return to top" data-id="element-91">
              Martin's AI Kit
            </Link>
            {/* Desktop Navigation */}
            <Flex display={{
            base: 'none',
            md: 'flex'
          }} gap={6} as="ul" listStyleType="none" data-id="element-92">
              {navLinks.map(link => <Box as="li" key={link.id} data-id="element-93">
                  <Link href={`#${link.id}`} onClick={e => {
                e.preventDefault();
                scrollToSection(link.id);
              }} color={isScrolled ? 'gray.700' : 'white'} fontWeight="medium" cursor="pointer" _hover={{
                color: isScrolled ? '#1E73BE' : 'whiteAlpha.800',
                textDecoration: 'none'
              }} transition="color 0.2s" data-id="element-94">
                    {link.label}
                  </Link>
                </Box>)}
            </Flex>
            {/* Mobile Menu Button */}
            <IconButton display={{
            base: 'flex',
            md: 'none'
          }} aria-label="Open navigation menu" icon={<Menu aria-hidden="true" data-id="element-96" />} onClick={onOpen} variant="ghost" color={isScrolled ? 'gray.700' : 'white'} _hover={{
            bg: isScrolled ? 'gray.100' : 'whiteAlpha.200'
          }} data-id="element-95" />
          </Flex>
        </Container>
      </Box>
      {/* Mobile Drawer */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} data-id="element-97">
        <DrawerOverlay data-id="element-98" />
        <DrawerContent data-id="element-99">
          <DrawerCloseButton aria-label="Close navigation menu" data-id="element-100" />
          <DrawerHeader data-id="element-101">Menu</DrawerHeader>
          <DrawerBody data-id="element-102">
            <VStack spacing={4} align="stretch" as="ul" listStyleType="none" data-id="element-103">
              {navLinks.map(link => <Box as="li" key={link.id} data-id="element-104">
                  <Link href={`#${link.id}`} onClick={e => {
                e.preventDefault();
                scrollToSection(link.id);
              }} fontSize="lg" fontWeight="medium" cursor="pointer" _hover={{
                color: 'blue.600',
                textDecoration: 'none'
              }} data-id="element-105">
                    {link.label}
                  </Link>
                </Box>)}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>;
});